<template>
    <div class="file-name-textarea">
        <label class="label">
            {{ $t('folderFileName') }}<Tooltip :text="tooltip || label"><i
                class="ag-icon ag-icon_table_info small info-icon" /></Tooltip>
        </label>
        <textarea class="path-textarea" placeholder="Enter Folder/File Name" :maxlength="maxLength" rows="1"
            v-model="localValue" ref="textareaRef" @input="autoResize"></textarea>
    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits, ref, onMounted, nextTick, watch } from 'vue'
import Tooltip from './tooltip.vue'
const props = defineProps({
    modelValue: { type: String, default: '' },
    maxLength: { type: Number, default: 1000 },
    tooltip: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

const localValue = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const charCount = computed(() => (localValue.value || '').length)

const textareaRef = ref(null)
const autoResize = () => {
    const el = textareaRef.value
    if (!el) return
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
}

onMounted(() => {
    nextTick(() => autoResize())
})

watch(localValue, () => nextTick(() => autoResize()))
</script>

<style scoped>
.file-name-textarea {
    padding-left: 0.5rem;
    margin-left: 16px;           
    padding-right: 55px;    
    width: 100%;
}
.label {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    color: #164B6C;
    font-weight: 700;
}

.title {
    color: #164B6C;
    font-weight: 700;
}

.optional {
    color: #6b7280;
    font-size: 0.85em;
}

.info-icon {
  color: #6c757d;
  margin-left: 0px;
  display: inline-flex;
  align-items: center;
}

.path-textarea {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 8px;
    font-size: 0.8rem;
    resize: none; /* disable manual resize so auto-resize controls height */
    overflow: hidden; /* hide scrollbar while auto-resizing */
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.path-textarea:focus,
.path-textarea:focus-visible {
    outline: none;
    box-shadow: none;
    border-color: #cbd5e1;
}

.path-textarea::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
.path-textarea::-webkit-scrollbar-track {
    background: transparent;
}
.path-textarea::-webkit-scrollbar-thumb {
    background-color: #cbd5e1; 
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: content-box;
}
.path-textarea::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}

.counter {
    text-align: right;
    color: #6b7280;
    font-size: 0.75rem;
    margin-top: 4px;
}
</style>